import PropTypes from 'prop-types';
import React from 'react';
import { lookerParams } from '../../../../../shared/lookerParams';
import OutputTab from '../OutputTab';

AddressableTab.propTypes = {
    activeTab: PropTypes.string,
    onLoadComplete: PropTypes.func,
};

function AddressableTab(props) {
    return (
        <OutputTab
            activeTab={props.activeTab}
            lookerTemplates={lookerParams.lookerPath.addressableTab}
            onLoadComplete={props.onLoadComplete}
            tabLabel="Addressable"
        />
    );
}

export default AddressableTab;
